export const INTEGRATION_EVENTS = [
  {
    label: 'CONTACT_CREATED',
    value: 'contact_created',
  },
  {
    label: 'CONTACT_UPDATED',
    value: 'contact_updated',
  },
  {
    label: 'MESSAGE_CREATED',
    value: 'message_created',
  },
];

export const WEBHOOK_TYPES = [
  { label: 'ACCOUNT_TYPE', value: 'account_type' },
  { label: 'INBOX_TYPE', value: 'inbox_type' },
];

export const ACCOUNT_TYPE_EVENTS = [
  'contact_created',
  'contact_updated',
  'message_created',
];
export const INBOX_TYPE_EVENTS = ['message_created'];
